import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADMIN, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const CreateShipmentErrorMappingList = () => {
	const defaultSort = useMemo(() => [{ id: 'thisWeek', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'id',
				accessor: 'id',
				filterType: FilterType.number,
				width: 50,
				show: false,
				showCopyButton: true,
				showOnMobile: true
			},
			{
				Header: 'integrationName',
				accessor: 'integrationName',
				filterType: FilterType.string,
				show: true,
				showOnMobile: true
			},
			{
				Header: 'actionType',
				accessor: 'actionType',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'aiResponseEN',
				accessor: 'aiResponseEN',
				filterType: FilterType.string,
				show: true
			},
			{
				Header: 'aiResponseAR',
				accessor: 'aiResponseAR',
				filterType: FilterType.string,
				show: true
			},
			{
				Header: 'aiResponseTR',
				accessor: 'aiResponseTR',
				filterType: FilterType.string,
				show: true
			},
			{
				Header: 'notificationThreshold',
				accessor: 'notificationThreshold',
				filterType: FilterType.number,
				show: true
			},
			{
				Header: 'fixed',
				accessor: 'fixed',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				show: true,
				showOnMobile: true
			},
			{
				Header: 'thisWeekErrors',
				accessor: 'thisWeek',
				filterType: FilterType.number,
				show: true
			},
			{
				Header: 'lastWeekErrors',
				accessor: 'lastWeek',
				filterType: FilterType.number,
				show: true
			},
			{
				Header: 'twoWeekErrors',
				accessor: 'twoWeekAgo',
				filterType: FilterType.number,
				show: true
			},
			{
				Header: 'total',
				accessor: 'totalCount',
				filterType: FilterType.number,
				show: true,
				showOnMobile: true
			},
			{
				Header: 'tag',
				accessor: 'tag',
				filterType: FilterType.string,
				show: true
			},
			{
				Header: 'errorCode',
				accessor: 'errorCode',
				filterType: FilterType.string,
				show: true
			},
			{
				Header: 'fixedAR',
				accessor: 'fixedAR',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				show: false
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.CREATE_SHIPMENT_ERROR_MAPPING}
				columns={columns}
				fetchUrl={ADMIN.GET_DC_AI_ERROR_LOGS_REPORT}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
				exportName="createShipmentErrorMapping"
			/>
		</TabTableContainer>
	);
};

export default CreateShipmentErrorMappingList;
